/**
 * Modern metric card — light surface, sentence-case label, large value.
 */
export function MetricCard({ label, value, icon: Icon, hint, testId }) {
  return (
    <div
      className="surface-card px-4 sm:px-5 py-4 sm:py-5 flex items-start gap-3 sm:gap-4"
      data-testid={testId}
    >
      {Icon && (
        <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-[#3B82F6]/10 text-[#3B82F6] shrink-0">
          <Icon size={16} />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <p className="text-xs sm:text-sm font-medium text-[#64748B] truncate">{label}</p>
        <p className="font-['Geist'] font-semibold text-xl sm:text-2xl lg:text-[28px] tracking-tight text-[#0F172A] mt-0.5 sm:mt-1">
          {value}
        </p>
        {hint && <p className="text-xs text-[#94A3B8] mt-1">{hint}</p>}
      </div>
    </div>
  );
}

export function MetricGrid({ children, columns = 4 }) {
  const colClass = {
    2: "sm:grid-cols-2",
    3: "grid-cols-2 sm:grid-cols-3",
    4: "grid-cols-2 lg:grid-cols-4",
  }[columns] || "grid-cols-2 lg:grid-cols-4";
  return <div className={`grid ${colClass} gap-3 sm:gap-4 mb-8`}>{children}</div>;
}
